module.exports = __webpack_public_path__ + "29da06864b6f2118a7524b19a6cf0099.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/venn_content_commerce.png
// module id = 219
// module chunks = 0